(function(){
  if(window.__spProduct)return; window.__spProduct=1;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){reveal();paws();});

  /* Details, photos and recommendations ease in as they scroll into view. */
  function reveal(){
    if(reduced||!('IntersectionObserver' in window))return;
    var els=[].slice.call(document.querySelectorAll('.product-details > *, .product-media-container, .sp-trust li, product-recommendations product-card, .product-recommendations .product-card'));
    if(!els.length)return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.classList.add('sp-in');
        io.unobserve(e.target);
      });
    },{threshold:.08,rootMargin:'0px 0px -30px 0px'});
    els.forEach(function(el,i){
      if(el.getBoundingClientRect().top<window.innerHeight){el.style.transitionDelay=(Math.min(i,6)*45)+'ms';}
      el.classList.add('sp-reveal');
      io.observe(el);
    });
  }

  /* A little burst of paws from the button on Add to basket. */
  function paws(){
    if(reduced)return;
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('add-to-cart-component button, .add-to-cart-button');
      if(!b||b.disabled)return;
      var r=b.getBoundingClientRect();
      var w=document.createElement('div');
      w.className='sp-popwrap';
      w.setAttribute('aria-hidden','true');
      w.style.left=(r.left+r.width/2)+'px';
      w.style.top=(r.top+r.height/2)+'px';
      for(var i=0;i<5;i++){
        var p=document.createElement('span');
        p.className='sp-paw';
        var a=(-150+i*30)*Math.PI/180;
        p.style.setProperty('--dx',Math.round(Math.cos(a)*90)+'px');
        p.style.setProperty('--dy',Math.round(Math.sin(a)*70-20)+'px');
        p.style.setProperty('--sp-rot',(i%2?18:-14)+'deg');
        p.style.animationDelay=(i*40)+'ms';
        w.appendChild(p);
      }
      document.body.appendChild(w);
      setTimeout(function(){w.remove();},1200);
    },true);
  }
})();